<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.buttons" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="spinButtons" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.separator" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="separator" /><!--
          --><checkbox label-size="xs" v-model="iconLeft" :label="$lang.iconLeft" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconRight" :label="$lang.iconRight" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" equal-height md12 sm24 v-for="(picker, index) in pickers" :key="index">
        <time-picker-field
          @input="onInput"
          :dense="dense"
          :spin-buttons="spinButtons"
          :disabled="disabled"
          :icon-right="iconRight ? 'timetable' : null"
          :icon-left="iconLeft ? 'clock' : null"
          :color="$root.$colors.primary"
          :segments="picker.show" :separator="separator ? ':' : null" :hour-cycle="picker.hourCycle"
          :initial-state="picker.initialState"
          :color-lightness="$root.$colors.bgColorLightness" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTimePickerField',
  mixins: [
    methods
  ],
  data () {
    return {
      pickers: [],
      dense: false,
      iconLeft: true,
      spinButtons: true,
      iconRight: false,
      disabled: false,
      separator: true
    }
  },
  mounted () {
    this.getExternalData('time-picker.json', 'pickers')
  },
  methods: {
    onInput ($event) {
      this.log('input', 'time-picker-field', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/time-picker-field.vue